import { react2angular } from 'react2angular';

import annoucementRoutes from './announcement.routes';
import AnnouncementRouter from './AnnouncementRouter';

/**
 * @deprecated This module is being deprecated under the "removeAngularFeature" flag.
 * Routes have been moved to [Router/pages/AnnouncementPages].
 */
angular
  .module('bb.announcement', ['ngRoute'])
  .config(annoucementRoutes)
  .component(
    'bbAnnouncementRouter',
    react2angular(AnnouncementRouter, [], ['$rootScope']),
  );
